import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "contract-list-btn"
};
import { computed, onMounted, reactive, ref, toRefs } from "vue";
import apis from "@/api";
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import ExamineStatus from "@/views/Advert/AdvertLaunchMonitor/components/ExamineStatus.vue";
export default {
  __name: 'AdvertLaunchCompanyList',
  props: {
    roleId: {
      type: String,
      default: ''
    },
    roleFlag: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['submit', 'audit'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emits = __emit;
    const detailLoading = ref(false);
    const close = () => {
      emits('update:visible', false);
    };
    const headerStyle = ref({
      background: '#FAFAFA'
    });
    const props = __props;
    const data = reactive({
      tableData: [],
      id: '',
      activeRow: {}
    });
    const init = row => {
      data.id = row.id;
      data.activeRow = row;
      loadData();
    };
    const loadData = () => {
      detailLoading.value = true;
      apis.listCompany({
        id: data.id
      }).then(res => {
        if (res.success) {
          data.tableData = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        detailLoading.value = false;
      });
    };
    const auditCompany = row => {
      // 打开审核页面
      emits("audit", row, data.activeRow);
      close();
    };
    onMounted(() => {});
    __expose({
      init
    });
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "选择供应商",
        "model-value": __props.visible,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true,
        width: "50%"
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          data: data.tableData,
          style: {
            "width": "100%"
          },
          "header-cell-style": headerStyle.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            fixed: "",
            prop: "roleName",
            label: "供应商"
          }), _createVNode(_component_el_table_column, {
            prop: "examineState",
            label: "状态",
            width: "150"
          }, {
            default: _withCtx(scope => [_createVNode(ExamineStatus, {
              state: scope.row.examineState
            }, null, 8, ["state"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "100"
          }, {
            default: _withCtx(scope => [_createElementVNode("div", _hoisted_1, [__props.roleFlag === '1' && scope.row.examineState === 2 ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              link: "",
              size: "small",
              type: "primary",
              onClick: $event => auditCompany(scope.row)
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("审核", -1)]))]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true)])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "header-cell-style"])), [[_directive_loading, detailLoading.value]])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
};